class ProductCategoriesController {
  constructor ($state, I18n) {
    'ngInject'
    this.$state = $state
    this.I18n = I18n
  }

  active (category) {
    return this.$state.is('vehicle.catalog.appsAndServices', {category: category.ref.toLowerCase()})
  }
}

export default ProductCategoriesController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/product-categories/product-categories.controller.js